import * as yup from 'yup';
import 'yup-phone';
import { i18n } from '@lt/localization';
import { FormFields } from './types';

export const phoneValidationSchema = yup.object({
  [FormFields.LoginByPhone]: yup
    .string()
    // в качестве первых двух параметров передаем undefined, чтобы оставить их дефолтными
    // третьим параметром передаем error-message
    .phone(
      undefined,
      undefined,
      i18n.t('checkout.registrationForm.phone.inputError'),
    )
    .required(i18n.t('checkout.registrationForm.phone.required')),
});

export const emailValidationSchema = yup.object({
  [FormFields.LoginByEmail]: yup
    .string()
    .matches(
      /^(([^<>()[\]\\/*=.,;:\s@"]{1,50}(\.[^<>()[\]\\/*=.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z0-9а-яА-ЯёЁ-]+\.)+[a-zA-Zа-яА-ЯёЁ]{2,}))$/,
      i18n.t('checkout.registrationForm.email.inputError'),
    )
    .required(i18n.t('checkout.registrationForm.email.required')),
});
